import { render } from "./EmeraldManagement.vue?vue&type=template&id=94cc3362&scoped=true"
import script from "./EmeraldManagement.vue?vue&type=script&lang=js"
export * from "./EmeraldManagement.vue?vue&type=script&lang=js"

import "./EmeraldManagement.vue?vue&type=style&index=0&id=94cc3362&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94cc3362"]])

export default __exports__